import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'aionz-quotation-map-board-skeleton',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './quotation-map-board-skeleton.component.html',
  styleUrl: './quotation-map-board-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuotationMapBoardSkeletonComponent {
  protected readonly supplierColumns = [1, 2, 3, 4];
  protected readonly productRows = [1, 2, 3, 4, 5];
}
